import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { InterStoreTransferActionTypes } from "./InterStoreTransfer.type";
import { formatQuery } from "../Utils";

export function* fetchAllInterStoreTransfers(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/inter-store-transfer?${formatQuery(action)}`);
    yield put({
      type: InterStoreTransferActionTypes.FETCH_ALL_INTER_STORE_TRANSFER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: InterStoreTransferActionTypes.FETCH_ALL_INTER_STORE_TRANSFER_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneInterStoreTransfers(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/inter-store-transfer/${action.payload}`
    );
    yield put({
      type: InterStoreTransferActionTypes.FETCH_ONE_INTER_STORE_TRANSFER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: InterStoreTransferActionTypes.FETCH_ONE_INTER_STORE_TRANSFER_FAILURE,
      payload: error,
    });
  }
}

export function* fetchPagedInterStoreTransfers(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/inter-store-transfer/paged?${formatQuery(action)}`
    );
    yield put({
      type: InterStoreTransferActionTypes.FETCH_PAGED_INTER_STORE_TRANSFER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: InterStoreTransferActionTypes.FETCH_PAGED_INTER_STORE_TRANSFER_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllInterStoreTransfers() {
  yield takeLatest(InterStoreTransferActionTypes.FETCH_ALL_INTER_STORE_TRANSFER, fetchAllInterStoreTransfers);
}

export function* watcherFetchOneInterStoreTransfers() {
  yield takeLatest(InterStoreTransferActionTypes.FETCH_ONE_INTER_STORE_TRANSFER, fetchOneInterStoreTransfers);
}


export function* watcherFetchPagedInterStoreTransfers() {
  yield takeLatest(
    InterStoreTransferActionTypes.FETCH_PAGED_INTER_STORE_TRANSFER,
    fetchPagedInterStoreTransfers
  );
}